import { actionCreator } from '@ardoq/rxbeach';
import type { TraversalLoadedState } from '@ardoq/api-types';
import type { MetamodelTraversal, PseudoTraversal } from './types';

export type TraversalOpenRequestedPayload = {
  metamodelTraversal: MetamodelTraversal;
  /** The loaded traversal the metamodel traversal changes; null for a new one. */
  loadedTraversal: TraversalLoadedState | null;
};

export const traversalOpenRequested =
  actionCreator<TraversalOpenRequestedPayload>(
    '[traversalBuilding] traversal open requested'
  );

export const traversalConstructed = actionCreator<PseudoTraversal>(
  '[traversalBuilding] traversal constructed'
);
